import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ContactsModel } from '../models/ContactsModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class ContactsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public GetContacts(ConCode: string ,ConType: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("ConCode", ConCode);
        params = params.append("ConType", ConType);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<ContactsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/GetContacts',options);
    }
    public AddContacts(contacts: ContactsModel) {

        return this.http.post<ContactsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/AddContacts', contacts);
    }
    public delContacts(ConCode: string ,ConType: string ) {

      let params = new HttpParams();
      params = params.append("docCode", ConCode);
      params = params.append("ConType", ConType);
        const options = {
          params: params
      };
      return this.http.get<ContactsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/DeleteContacts',options);
    }
    public getContactsLookup(ConCode: string, ConAName: string) {
      let params = new HttpParams();
      params = params.append("ConCode", ConCode);
      params = params.append("ConAName", ConAName);
      const options = {
          params: params
      };
      return this.http.get<ContactsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/ContactsLookup', options);
    }

    public getContactsLookupTop(CompCode : string) {
      let params = new HttpParams();
      params = params.append("CompCode", CompCode);
      const options = {

          params: params
      };
      return this.http.get<ContactsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/ContactsLookupTop', options);
    }

    public getConLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<ContactsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/ContactsLookupTop', options);

    }

    public GetNextSerial() {
      let params = new HttpParams();
        const options = {
            params: params
        };
        return this.http.get<ContactsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/GetContactsSerial',options);
    }

    public getAllContactsLookupTop(ContactCode : string,ContactName : string) {
      let params = new HttpParams();
      params = params.append("ContactCode", ContactCode);
      params = params.append("ContactName", ContactName);
      const options = {

          params: params
      };
      return this.http.get<ContactsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/AllContactsLookupTop', options);
    }

    public getAllContactsLookup(ContactCode : string,ContactName : string,ContactType : string,Telephon1 : string,Telephon2 : string,Telephon3 : string,Mobile : string) {
      let params = new HttpParams();
      params = params.append("ContactCode", ContactCode);
      params = params.append("ContactName", ContactName);
      params = params.append("ContactType", ContactType);
      params = params.append("Telephon1", Telephon1);
      params = params.append("Telephon2", Telephon2);
      params = params.append("Telephon3", Telephon3);
      params = params.append("Mobile", Mobile);
      const options = {

          params: params
      };
      return this.http.get<ContactsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Contacts/AllContactsLookup', options);
    }
  }
